@if (counter > 0) {
<span class="notification">
  {{counter}}
</span>
}
